import React, { useEffect, useMemo, useState } from "react";
import ProgressBar from "../../../components/ProgessBar";
import Label from "../../../components/Label";
import { useDispatch, useSelector } from "react-redux";
import SelectedAccountModal from "../../../components/Modals/SelectAccount/SelectAccountModal";
import {
  FormatBalance,
  FormatTRDate,
  GetCurrenySymbol,
  GetValidationErrors,
} from "../../../helper";
import { Dropdown, FormInputField } from "../../../components";
import { useDeleteDocument, useForm } from "../../../hooks";
import {
  depositTR,
  updateDepositTR,
} from "../../../redux/actions/TRrequest/Deposit";
import CancelTransactionModal from "../../../components/Modals/CancelTransactionModal";
import { PrimaryButton, SmallButton } from "../../../components/Buttons";
import TransactionOTPModal from "../../../components/Modals/TransactionsOTPModal";
import { Review, TransactionDetail } from "../../../components/Transactions";
import Steps from "../../../components/Common/Steps";
import AccountDropdown from "../../../components/Common/AccountDropdown";
import { verifyTROTP } from "../../../redux/actions/TRrequest/OTPVerification";
import { setPageTitle } from "../../../helper/metaDataHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { getTransactionDetails } from "../../../redux/actions/Transaction/TransactionHistory";
import { setActiveAccount } from "../../../redux/actions/home/ActiveAccountAction";
import ErrorMessage from "../../../components/Common/ErrorMessage";
import PreviousDocs from "../../../components/Common/PreviousDocs";
import MultipleFileUpload from "../../../components/MultipleFileUpload";
import { ValidateFileSize } from "../../../utils/ValidateFileSize";
import InitialsAvatar from "../../../components/Common/InitialsAvatar";
import CommonButton from "../../../components/Buttons/CommonButton";
import ListItem from "../../../components/Modals/Beneficiary/partails/ListItem";
import CopyToClipboard from "../../../helper/CopyToClipboard";
import CustomTransition from "../../../components/CustomTransition";
import useTransactionMethods from "../../../hooks/useTransactionMethods";
import usePaymentTypes from "../../../hooks/usePaymentTypes";
import Accordion from "../../../components/Accordion";
import BankDetailsInput from "../../../components/Modals/BankDetailsModal/partials";

const Deposit = () => {
  const [step, setStep] = useState(1);
  const labels = ["Deposit Amount", "Review"];
  const location = useLocation();
  const { documents, setDocuments, handleDeleteDocument } = useDeleteDocument(
    [],
  );
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);

  // this need to be fixed from api side to get only the fiat accounts
  const fiatAccounts = useSelector((state) =>
    state.client.clientInfo.accounts.filter(
      (account) => account.is_crypto === 0 || account.is_crypto === null,
    ),
  );
  const { activeAccount } = useSelector((state) => state.activeAccount);
  const [loading, setLoading] = useState(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [trn_id, setTrnId] = useState("");
  const [error, setError] = useState([]);

  const amountInput = useForm("", "amount");
  const remarksInput = useForm("");
  const transferType = useForm("");
  const [supportingDocument, setSupportingDocument] = useState("");
  const transactionDate = FormatTRDate(new Date());
  const [isDepositConfirmed, setIsDepositConfirmed] = useState(false);
  const navigate = useNavigate();
  const [fileValidationError, setFileValidationError] = useState(false);

  // eslint-disable-next-line
  const [transactionType, getMethodBylable] = useTransactionMethods(setLoading);
  // eslint-disable-next-line
  const [selectedType, setSelectedType] = useState("");
  
  const [paymentType, getPaymentBylable] = usePaymentTypes(setLoading);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const isValidValue = (value) =>
    value !== null && value !== undefined && value !== "" && value !== "N/A";

  const virtualData = useMemo(() => {
    if (!activeAccount?.virtual_account_info) return null;
    try {
      const parsed =
        typeof activeAccount.virtual_account_info === "string"
          ? JSON.parse(activeAccount.virtual_account_info)
          : activeAccount.virtual_account_info;

      if (Object.keys(parsed).length === 0) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }, [activeAccount]);

  /**
   * Derive routing details safely
   */
  const routingDetails = useMemo(() => {
    if (!activeAccount?.routing_code_entries) return null;

    try {
      const entries =
        typeof activeAccount.routing_code_entries === "string"
          ? JSON.parse(activeAccount.routing_code_entries)
          : activeAccount.routing_code_entries;

      const entry = entries?.[0];
      if (!entry?.routingCodeValue) return null;

      return {
        key: entry.routingCodeKey,
        label:
          entry.routingCodeKey === "ROUTING_NUMBER"
            ? "Routing number"
            : "Sort code",
        value: entry.routingCodeValue,
      };
    } catch {
      return null;
    }
  }, [activeAccount]);

  useEffect(() => {
    setPageTitle("Deposit");
  }, []);

  useEffect(() => {
    if (!activeAccount.is_sepa) {
      setLoading(true);
      setSelectedType("SWIFT");
      const method = getMethodBylable("SWIFT");

      if (method) {
        transferType.setValue(method.id);
      }

      setLoading(false);
    } else {
      setSelectedType("");
      transferType.setValue("");
    }
    // eslint-disable-next-line
  }, [activeAccount]);

  const handleNext = () => {
    if (!validateDeposit()) return;
    if (step < labels.length + 1) setStep(step + 1);
  };

  const handlePrev = () => {
    if (step > 1 && !isDepositConfirmed) setStep(step - 1);
  };

  const handleDeposit = async () => {
    setIsOTPModalOpen(true);
    setLoading(true);

    const formData = new FormData();

    formData.append("account_id", activeAccount.id);
    formData.append("amount", amountInput.value);
    formData.append("remarks", remarksInput.value);
    formData.append("transaction_date", transactionDate);
    formData.append("payment_type_id", selectedPaymentType);

    if (transferType.value) {
      formData.append("transaction_method_id", transferType.value);
    } else {
      const method = getMethodBylable("SWIFT");
      formData.append("transaction_method_id", method.id);
    }

    if (supportingDocument) {
      Object.keys(supportingDocument).forEach((key) => {
        supportingDocument[key].forEach((file) => {
          formData.append("supporting_documents[]", file);
        });
      });
    }

    let res;

    try {
      if (location.state) {
        formData.append("trn_id", location.state);
        res = await dispatch(updateDepositTR(formData));
      } else {
        res = await dispatch(depositTR(formData));
      }

      setLoading(false);

      if (res.success) {
        setIsOTPModalOpen(true);
        setTrnId(res.data.trn_id);
        setIsDepositConfirmed(true);
        location.state = null;
      } else if (!res.success) {
        if (res.errors) {
          setError(GetValidationErrors(res.errors));
        } else {
          setError(res.error);
        }
        setStep(1);
        setIsOTPModalOpen(false);
        setTimeout(() => {
          setLoading(false);
        }, 500);
        return;
      }
    } catch (error) {
      setLoading(false);
      setIsOTPModalOpen(false);
      setStep(1);
    }
  };

  useEffect(() => {
    if (location.state) {
      // get transaction details
      const fetchTransactionDetails = async () => {
        const data = {
          trn_id: location.state,
          transaction_nature: "TT",
        };
        setLoading(true);
        const res = await dispatch(getTransactionDetails(data));

        if (res.success) {
          amountInput.setValue(res.data.amount);
          remarksInput.setValue(res.data.remarks);
          const account = fiatAccounts.find(
            (account) => account.id === res.data.account_id,
          );
          if (account) {
            dispatch(setActiveAccount(account));
          }

          if (res.data.docs && res.data.docs.length > 0) {
            setDocuments(res.data.docs);
          }
        }
        setLoading(false);
      };
      fetchTransactionDetails();
    }
  }, [location.state, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  const validateDeposit = () => {
    let validate = true;
    setError("");

    if (amountInput.validate()) {
      validate = false;
      amountInput.setError("Please enter a valid amount.");
    }
    if (!remarksInput.value) {
      validate = false;
      remarksInput.setError("Please enter remarks.");
    }

    if (!selectedPaymentType) {
      validate = false;
      setError("Please select transaction type.");
    }

    setStep(1);

    return validate;
  };

  const handleViewTransaction = async () => {
    setIsOTPModalOpen(false);
    setStep(1);
    navigate("/all-transactions");
  };

  const handleFileChange = (name, selectedFiles) => {
    const sizeErrors = [];

    Array.from(selectedFiles).forEach((file) => {
      const { isValid, error } = ValidateFileSize(file);
      if (!isValid) {
        sizeErrors.push(error);
      }
    });

    if (sizeErrors.length > 0) {
      setError(sizeErrors);
      setFileValidationError(true);
      return;
    }

    setSupportingDocument((prevFiles) => {
      const updatedFiles = { ...prevFiles, [name]: selectedFiles };
      if (!selectedFiles.length) {
        delete updatedFiles[name];
        return "";
      }
      return updatedFiles;
    });
    setFileValidationError(false);
    if (error) {
      setError([]);
    }
  };

  const isContinueEnabled =
    amountInput.value &&
    remarksInput.value &&
    (supportingDocument || documents.length > 0) &&
    !fileValidationError;

  // eslint-disable-next-line
  const [copiedText, setCopiedText] = useState("");
  // eslint-disable-next-line
  const [isCopied, setIsCopied] = useState(false);
  const [message, setIsMessage] = useState("");

   const renderAccountInfo = (accountInfo) => {
    // =========================================
    // NEW ZENUS STRUCTURE
    // =========================================
    if (accountInfo?.accounts && Array.isArray(accountInfo.accounts)) {
      return (
        <>
          {/* Accounts */}
          <div className="pt-2 space-y-3">
            {accountInfo.accounts.map((account, index) => (
              <Accordion
                key={index}
                defaultOpen={false}
                title={account?.title || `Account ${index + 1}`}
              >
                {/* =========================================
                    SWIFT SECTIONS
                ========================================= */}
                {Array.isArray(account?.sections) &&
                  account.sections.map((section, sectionIndex) => (
                    <div
                      key={sectionIndex}
                      className="space-y-3 mb-5"
                    >
                      <h3 className="text-sm font-semibold text-text-primary">
                        {section.title}
                      </h3>

                      <div className="space-y-3">
                        {Object.entries(section.fields || {}).map(
                          ([label, value]) => renderZenusField(label, value, `${account.type}-${section.title}-${label}`)
                        )}
                      </div>
                    </div>
                  ))}

                {/* =========================================
                    NORMAL FIELDS (ACH/FEDWIRE)
                ========================================= */}
                {!account?.sections && (
                  <div className="space-y-3">
                    {Object.entries(account?.fields || {}).map(
                      ([label, value]) => renderZenusField(label, value, `${account.type}-${label}`)
                    )}
                  </div>
                )}

                {/* =========================================
                    COPY BUTTON
                ========================================= */}
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => handleCopyAccountDetails(account)}
                    className="px-4 py-2 !text-xs font-medium common-lable rounded-xl border border-divider bg-background-secondary hover:bg-background-muted transition-all duration-200"
                  >
                    Copy {account?.title || account?.type} Details
                  </button>
                </div>
              </Accordion>
            ))}
          </div>
        </>
      );
    }

    // =========================================
    // OLD STRUCTURE FALLBACK
    // =========================================
    if (!Array.isArray(accountInfo) || !accountInfo.length) {
      return null;
    }

    const baseAccount = accountInfo[0];

    const routing = accountInfo.reduce((acc, item) => {
      const type = item?.financialInstitutionId?.type;
      const value = item?.financialInstitutionId?.value;
      const isVRN = item?.accountNumberSubtype === "VRN";

      if (isVRN && item?.accountNumber?.value) {
        acc.VRN = item.accountNumber.value;
      }

      if (type && value) {
        acc[type] = value;
      }

      return acc;
    }, {});

    return (
      <>
        {renderField("Beneficiary name", activeAccount?.bank_account_holder_name, "beneficiaryname")}
        {renderField("Bank name", activeAccount?.bank_name, "bankName")}
        {renderField("Account number", activeAccount?.virtual_account_number, "virtualAccountNumber")}
        {renderField("IBAN", activeAccount?.iban, "iban")}
        {routingDetails && renderField(routingDetails.label, routingDetails.value, routingDetails.key)}
        {renderField("Bank Address", activeAccount?.bank_address, "bankAddress")}
        {routing?.ABA_CODE && renderField("Routing Code", routing.ABA_CODE, "routingCode")}
        {routing?.BIC && renderField("BIC/Swift Code", routing.BIC, "bic")}
        {routing?.VRN && renderField("VRN", routing.VRN, "vrn")}
        {renderField("Currency", baseAccount?.defaultCurrencyCode, "currency")}
      </>
    );
  };

  /**
   * Copy all visible details
   */
  const handleCopyAll = () => {
    if (!activeAccount) return;

    const details = [];

    // =========================================
    // ZENUS HANDLING
    // =========================================
    if (activeAccount?.virtual_provider === "zenus" && activeAccount?.virtual_account_info?.accounts) {
      const virtualInfo = activeAccount.virtual_account_info;

      // Accounts
      virtualInfo.accounts.forEach((account) => {
        details.push(
          `\n================================`,
          `${account.title || account.type}`,
          `================================`
        );

        // =====================================
        // SWIFT SECTIONS
        // =====================================
        if (Array.isArray(account.sections)) {
          account.sections.forEach((section) => {
            details.push(`\n${section.title}`);

            Object.entries(section.fields || {}).forEach(
              ([label, value]) => {
                if (isValidValue(value)) {
                  details.push(`${label}: ${value}`);
                }
              }
            );
          });
        }

        // =====================================
        // ACH / FEDWIRE
        // =====================================
        else if (account.fields) {
          Object.entries(account.fields).forEach(
            ([label, value]) => {
              if (isValidValue(value)) {
                details.push(`${label}: ${value}`);
              }
            }
          );
        }
      });
    }

    // =========================================
    // LORUM HANDLING
    // =========================================
    else if (activeAccount?.virtual_provider === "lorum" && activeAccount?.virtual_account_info) {
      const info = activeAccount.virtual_account_info;

      details.push(
        `================================`,
        `${activeAccount.title || "Account Details"}`,
        `================================`
      );

      // General bank info (top-level)
      const generalFields = [
        ["Beneficiary Name", info.beneficiary_name],
        ["Bank Name", info.bank_name],
        ["Currency", info.currency],
        ["Swift Code", info.swift_code],
        ["Bank Address", info.bank_address],
        ["Account Opened Date", info.account_opened_date],
        ["Beneficiary Address", info.beneficiary_address],
      ];

      generalFields.forEach(([label, value]) => {
        if (isValidValue(value)) {
          details.push(`${label}: ${value}`);
        }
      });

      // Accounts (SWIFT / FEDWIRE / ACH etc)
      if (Array.isArray(info.accounts)) {
        info.accounts.forEach((account) => {
          details.push(
            `\n--------------------------------`,
            `${account.type || "Account"}`,
            `--------------------------------`
          );

          const accountFields = [
            ["Account Number", account.account_number],
            ["IBAN", account.iban],
            ["Routing Number", account.routing_number],
          ];

          accountFields.forEach(([label, value]) => {
            if (isValidValue(value)) {
              details.push(`${label}: ${value}`);
            }
          });
        });
      }
    }


    // =========================================
    // NORMAL SEPA
    // =========================================
    else if (activeAccount?.is_sepa) {
      [
        ["Beneficiary name", activeAccount.bank_account_holder_name],
        ["Bank name", activeAccount.bank_name],
        ["Account number", activeAccount.virtual_account_number],
        ["IBAN", activeAccount.iban],
        ["BIC", activeAccount.bic],
        [routingDetails?.label, routingDetails?.value],
        ["Currency", activeAccount.currency_code],
        ["Bank Address", activeAccount.bank_address],
      ]
        .filter(([, value]) => isValidValue(value))
        .forEach(([label, value]) => {
          details.push(`${label}: ${value}`);
        });
    }

    // =========================================
    // BASIC ACCOUNT
    // =========================================
    else {
      [
        ["Beneficiary name", activeAccount.title],
        ["Account number", activeAccount.account_number],
      ]
        .filter(([, value]) => isValidValue(value))
        .forEach(([label, value]) => {
          details.push(`${label}: ${value}`);
        });
    }

    // =========================================
    // COPY
    // =========================================
    CopyToClipboard(
      details.join("\n").trim(),
      setCopiedText,
      setIsCopied,
      setIsMessage,
      "Bank details copied"
    );
  };


  const handleCopy = (text, field) => {
    if (!isValidValue(text)) return;
    CopyToClipboard(
      text,
      setCopiedText,
      setIsCopied,
      setIsMessage,
      `${field} copied`,
    );
  };
  


  // =========================================
  // COPY SINGLE ACCOUNT DETAILS
  // =========================================
  const handleCopyAccountDetails = (account) => {
    if (!account) return;

    const details = [];

    // =====================================
    // TITLE
    // =====================================
    details.push(
      "================================",
      `${account.title || account.type}`,
      "================================"
    );

    // =====================================
    // SWIFT STRUCTURE
    // =====================================
    if (Array.isArray(account?.sections)) {
      account.sections.forEach((section) => {
        details.push(`\n${section.title}`);

        Object.entries(section.fields || {}).forEach(
          ([label, value]) => {
            if (isValidValue(value)) {
              details.push(`${label}: ${value}`);
            }
          }
        );
      });
    }

    // =====================================
    // ACH / FEDWIRE
    // =====================================
    else if (account?.fields) {
      Object.entries(account.fields).forEach(
        ([label, value]) => {
          if (isValidValue(value)) {
            details.push(`${label}: ${value}`);
          }
        }
      );
    }

    // =====================================
    // COPY
    // =====================================
    CopyToClipboard(
      details.join("\n").trim(),
      setCopiedText,
      setIsCopied,
      setIsMessage,
      `${account.title || account.type} details copied`
    );
  };

  const renderField = (label, value, name) =>
    isValidValue(value) && <ListItem title={label} value={value} />;

  /**
   * Reusable input renderer
   */
  const renderZenusField = (label, value, name) => isValidValue(value) && (
      <BankDetailsInput
        label={label}
        value={value}
        name={name}
        onCopy={() => handleCopy(value, label)}
        isCopied={copiedText === value && isCopied}
      />
    );

  return (
    <div className="max-w-[992px] mx-auto">
      <div className="inline-flex space-x-2 px-2 pb-8">
        <CancelTransactionModal contextLabel="Cancel Deposit">
          <SmallButton text={"Cancel Deposit"} cancel={true} />
        </CancelTransactionModal>
      </div>

      <>
        <div className="flex flex-col md:items-center md:justify-center">
          <Steps step={step} labels={labels} />
          <ProgressBar step={step} labels={labels} />
        </div>
        <div className="flex flex-col items-center justify-center md:p-6">
          <div className="py-4">
            {step === 1 && (
              <div className="space-y-4 md:max-w-[375px] w-[375px] max-[360px]:w-[340px]">
                {error.length > 0 && (
                  <ErrorMessage message={error} onClose={() => setError("")} />
                )}

                <h3 className="text-sm font-normal text-text-secondary mb-4">
                  You're Balance:{" "}
                  <span
                    className={`text-text-primary text-sm font-bold tracking-tight
                  ${activeAccount.balance <= 0 && "text-error-500"}
                  `}
                  >
                    {FormatBalance(activeAccount.balance)}{" "}
                    {activeAccount.currency_code}
                  </span>
                </h3>
                <div className="mb-4">
                  <Label
                    className="block text-sm font-medium text-text-primary mb-3"
                    htmlFor="account"
                    text="Select account"
                  />
                  <SelectedAccountModal
                    activeAccount={activeAccount}
                    clientAccounts={fiatAccounts}
                  >
                    <AccountDropdown activeAccount={activeAccount} />
                  </SelectedAccountModal>
                  {error.accountError && (
                    <span className="text-error-500 text-sm px-2">
                      {error.accountError}
                    </span>
                  )}
                </div>

                {activeAccount.is_sepa && (
                  <>
                    {/* <Dropdown
                      id="transferType"
                      name="transferType"
                      placeholder="Select a transfer type"
                      label="Transfer Type"
                      options={transactionType}
                      onChange={(e) => {
                        transferType.setValue(e.target.value);
                        const selectedOption = transactionType.find(
                          (option) => option.value === e.target.value,
                        );
                        setSelectedType(
                          selectedOption ? selectedOption.label : "",
                        );
                      }}
                      value={transferType.value}
                    /> */}

                    <CustomTransition
                      // show={selectedType === "Instant Payment"}
                      show={activeAccount.is_sepa}
                      enter={"transition ease-in duration-200"}
                      enterFrom={"transform opacity-0 scale-95"}
                      enterTo={"transform opacity-100 scale-100"}
                      leave={"transition ease-out duration-200"}
                      leaveFrom={"transform opacity-100 scale-200"}
                      leaveTo={"transform opacity-0 scale-95"}
                    >
                      <div className="flex flex-col w-full">
                        <div className="flex items-center space-x-3 py-4">
                          <InitialsAvatar
                            name={
                              virtualData?.beneficiary_name ||
                              activeAccount.bank_account_holder_name
                            }
                          />
                          <div className="text-text-primary text-base font-medium tracking-tight">
                            {virtualData?.beneficiary_name ||
                              activeAccount.bank_account_holder_name}{" "}
                          </div>
                        </div>
                        <hr className="mb-4 border border-background-secondary dark:border-divider" />
                        {virtualData ? (

                          <>
                            
                            {
                              activeAccount.virtual_provider === "zenus" ?
                              (
                                <div>
                                  {activeAccount?.is_sepa && renderAccountInfo(virtualData)}
                                </div>
                              ) : (
                              <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full mb-4">
                                  {renderField("Beneficiary name", virtualData.beneficiary_name)}
                                  {renderField("Beneficiary address", virtualData.beneficiary_address)}
                                  {renderField("Bank name", virtualData.bank_name)}
                                  {renderField("Bank Address", virtualData.bank_address)}
                                  {renderField("Currency", virtualData.currency)}
                                  {renderField("Swift code", virtualData.swift_code)}

                                  <div className="pt-2 w-full sm:col-span-2">
                                    {virtualData.accounts?.map((acc, index) => {
                                      const accordionTitle = acc.type
                                        ? `${acc.type}`
                                        : acc.iban
                                          ? "IBAN"
                                          : `Account ${index + 1}`;

                                      return (
                                        <Accordion
                                          key={index}
                                          title={accordionTitle}
                                        >
                                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
                                            {" "}
                                            {renderField("Account number", acc.account_number)}
                                            {renderField("Routing number", acc.routing_number)}
                                            {renderField("IBAN", acc.iban)}
                                          </div>
                                        </Accordion>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                              )
                            }                          

                          </>

                        ) : (
                          /* TIER 2: SEPA Account Details Flow */
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
                            {renderField("Beneficiary name", activeAccount.bank_account_holder_name, "beneficiaryname")}
                            {renderField("Bank name", activeAccount.bank_name, "bankName")}
                            {renderField("Account number", activeAccount.virtual_account_number, "virtualAccountNumber")}
                            {renderField("IBAN", activeAccount.iban, "iban")}
                            {renderField("BIC code", activeAccount.bic, "bic")}

                            {routingDetails && renderField(routingDetails.label, routingDetails.value, routingDetails.key)}

                            {renderField("Currency code", activeAccount.currency_code, "currency")}
                            {renderField("Bank Address", activeAccount.bank_address, "bankAddress")}
                          </div>
                        )}

                        <div className="pt-4">
                          <CommonButton onClick={handleCopyAll}>
                            Copy details
                          </CommonButton>
                        </div>
                        {message && (
                          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-auto px-4 py-2 border border-transparent dark:border-divider rounded-lg bg-[#0F0F0F] shadow-md">
                            <p className="text-white text-sm font-normal tracking-[0.07px]">
                              {message}
                            </p>
                          </div>
                        )}
                      </div>
                    </CustomTransition>
                  </>
                )}

                <CustomTransition
                  // show={selectedType === "Transfer" || !activeAccount.is_sepa}
                  show={!activeAccount.is_sepa}
                  enter={"transition ease-in duration-200"}
                  enterFrom={"transform opacity-0 scale-95"}
                  enterTo={"transform opacity-100 scale-100"}
                  leave={"transition ease-out duration-200"}
                  leaveFrom={"transform opacity-100 scale-200"}
                  leaveTo={"transform opacity-0 scale-95"}
                >
                  <div className="space-y-3">
                    <div>
                      <FormInputField
                        label="Amount"
                        name="amount"
                        id="amount"
                        type="number"
                        placeholder="Enter amount"
                        required={true}
                        currency={GetCurrenySymbol(
                          activeAccount.currency_code.split(" ")[0],
                          "13",
                          "13",
                        )}
                        {...amountInput}
                      />
                    </div>
                    <div>
                      <FormInputField
                        label="Remarks"
                        name="remarks"
                        id="remarks"
                        type="text"
                        placeholder="Add note"
                        {...remarksInput}
                      />
                    </div>
                    <div>
                      <Dropdown
                        id="paymentType"
                        name="paymentType"
                        placeholder="Select a transaction type"
                        label="Transaction Type"
                        options={paymentType}
                        onChange={(e) => {
                          setSelectedPaymentType(e.target.value);
                        }}
                        value={selectedPaymentType}
                      />
                    </div>
                    <div>
                      <FormInputField
                        label="Transaction Date"
                        name="transaction_date"
                        id="transaction_date"
                        type="text"
                        value={transactionDate}
                        onChange={() => {}}
                        readOnly
                      />
                    </div>
                    <div>
                      <MultipleFileUpload
                        name="supporting_documents"
                        id="supporting_documents"
                        title={"Supporting document"}
                        onChange={handleFileChange}
                        isMultiple={true}
                        maxCount={5}
                        mandatory={true}
                        files={files}
                        setFiles={setFiles}
                      />
                    </div>

                    <PreviousDocs
                      documents={documents}
                      handleDeleteDocument={handleDeleteDocument}
                    />

                    <hr className="flex-grow w-full md:w-96 border-divider" />
                    <div className="flex md:w-96 w-full">
                      <PrimaryButton
                        onClick={handleNext}
                        disabled={!isContinueEnabled}
                        text="Continue"
                      />
                    </div>
                  </div>
                </CustomTransition>
              </div>
            )}
            {step === 2 && (
              <div className="md:w-[568px] px-2">
                <Review
                  handlePrev={handlePrev}
                  handleTransaction={handleDeposit}
                  amount={`${amountInput.value} ${activeAccount.currency_code}`}
                  supportingDocument={supportingDocument}
                  message=" will be added to the below account details."
                  isTransactionConfirmed={isDepositConfirmed}
                >
                  <TransactionDetail
                    label="You're adding"
                    value={`${amountInput.value} ${activeAccount.currency_code}`}
                  />
                  <TransactionDetail label="Nature" value="Deposit" />
                  <hr className="flex w-full border-divider" />
                  <TransactionDetail
                    label="Account name"
                    value={activeAccount.title}
                  />
                  <TransactionDetail
                    label="Recipient account number"
                    value={activeAccount.account_number}
                  />
                  <hr className="w-full border-divider" />
                  <TransactionDetail
                    label="Remarks"
                    value={remarksInput.value}
                  />
                  <TransactionDetail
                    label="Transaction type"
                    value={getPaymentBylable(selectedPaymentType)}
                  />
                </Review>
              </div>
            )}
          </div>
        </div>
      </>
      <TransactionOTPModal
        isLoading={loading}
        setisLoading={setLoading}
        TrnId={trn_id}
        setTrnId={setTrnId}
        isModalOpen={isOTPModalOpen}
        setIsModalOpen={setIsOTPModalOpen}
        handleTransaction={handleDeposit}
        reduxaction={verifyTROTP}
        navigateUrl="/"
        handleViewTransaction={handleViewTransaction}
      />
    </div>
  );
};

export default Deposit;
